<template>
    <section class="assessmentSection questionsSection">
        <div class="pageContent">
            <header class="sectionHeader">
                <div class="pageTitle">Select your equipment</div>
            </header>

            <AocView>
                <section class="aocEquipment">

                    <!-- ANALYZED && TRUEAdvice -->
                    <transition name="fade">
                        <section class="equipmentSection"
                                 v-if="areaOfConcern.analyzed">

                            <!-- Recommended Equipment  -->
                            <section v-if="recommended.qty > 0">
                                <div class="analyzed-info">
                                    <div class="analyzed-info-title">
                                        Select an option
                                    </div>
                                    <div class="analyzed-info-desc">
                                        Need help deciding?
                                        <br> Ask us a question in chat.
                                    </div>
                                </div>
                                <section class="areaEquipmentSection">
                                    <!-- RECOMMENDED EQUIPMENT -->
                                    <true-panel class="area-equipment-panel"
                                                @click.native="selectEquipment('recommended')">
                                        <div class="equipment-listing">
                                            <div class="equipment-listing-image">
                                                <img :src="recommended.item.image"
                                                     :alt="recommended.item.name">
                                            </div>
                                            <div class="equipment-listing-title">
                                                <div class="equipment-listing-name">
                                                    {{ recommended.qty }} {{ recommended.item.name }}{{ recommended.qty > 1 ? 's' : '' }}
                                                </div>
                                                <div class="equipment-listing-location">
                                                    <!-- Total Price -->
                                                    <span class="item-total">
                                            ${{ (recommended.item.price * recommended.qty).toLocaleString('en') }}
                                            <span class="sep"></span>
                                                    </span>

                                                    <!-- Item Price -->
                                                    <span class="item-price">
                                            ${{ recommended.item.price.toLocaleString('en') }}/ea
                                            <span class="sep"></span>
                                                    </span>

                                                    <!-- Label -->
                                                    <span class="equipment-listing-label">Recommended</span>
                                                </div>
                                            </div>
                                            <div class="areaEquipmentSelectionSection">
                                                <div class="button selectButton"
                                                     v-if="!recommendedChosen">
                                                    Select
                                                </div>
                                                <div v-if="recommendedChosen">
                                                    <img class="checkmark"
                                                         src="/img/checkmark.png"
                                                         alt="Checkmark">
                                                </div>
                                            </div>
                                        </div>
                                    </true-panel>

                                    <!-- ALTERNATIVE -->
                                    <true-panel class="area-equipment-panel"
                                                v-if="alternative"
                                                @click.native="selectEquipment('alternative')">
                                        <div class="equipment-listing">
                                            <div class="equipment-listing-image">
                                                <img :src="alternative.item.image"
                                                     :alt="alternative.item.name">
                                            </div>
                                            <div class="equipment-listing-title">
                                                <div class="equipment-listing-name">
                                                    {{ alternative.qty }} {{ alternative.item.name }}{{ alternative.qty > 1 ? 's' : '' }}
                                                </div>
                                                <div class="equipment-listing-location">
                                                    <!-- Total Price -->
                                                    <span class="item-total">
                                            ${{ (alternative.item.price * alternative.qty).toLocaleString('en') }}
                                            <span class="sep"></span>
                                                    </span>

                                                    <!-- Item Price -->
                                                    <span class="item-price">
                                            ${{ alternative.item.price.toLocaleString('en') }}/ea
                                            <span class="sep"></span>
                                                    </span>

                                                    <!-- Label -->
                                                    <span class="equipment-listing-label">Alternative</span>
                                                </div>
                                            </div>
                                            <div class="areaEquipmentSelectionSection">
                                                <div class="button selectButton"
                                                     v-if="!alternativeChosen">
                                                    Select
                                                </div>
                                                <div v-if="alternativeChosen">
                                                    <img class="checkmark"
                                                         src="/img/checkmark.png"
                                                         alt="Checkmark">
                                                </div>
                                            </div>
                                        </div>
                                    </true-panel>

                                    <!-- MOTION -->
                                    <true-panel v-if="areaOfConcern.interestedInMotion"
                                                class="area-equipment-panel"
                                                @click.native="selectEquipment('motion')">
                                        <div class="equipment-listing">
                                            <div class="equipment-listing-image">
                                                <img :src="motion.item.image"
                                                     :alt="motion.item.name">
                                            </div>
                                            <div class="equipment-listing-title">
                                                <div class="equipment-listing-name">
                                                    {{ motion.qty }} {{ motion.item.name }}{{ motion.qty > 1 ? 's' : '' }}
                                                </div>
                                                <div class="equipment-listing-location">
                                                    <!-- Total Price -->
                                                    <span class="item-total">
                                            ${{ (motion.item.price * motion.qty).toLocaleString('en') }}
                                            <span class="sep"></span>
                                                    </span>

                                                    <!-- Item Price -->
                                                    <span class="item-price">
                                            ${{ motion.item.price.toLocaleString('en') }}/ea
                                            <span class="sep"></span>
                                                    </span>

                                                    <!-- Label -->
                                                    <span class="equipment-listing-label">Alternative</span>
                                                </div>
                                            </div>
                                            <div class="areaEquipmentSelectionSection">
                                                <div class="button selectButton"
                                                     v-if="!motionChosen">
                                                    Select
                                                </div>
                                                <div v-if="motionChosen">
                                                    <img class="checkmark"
                                                         src="/img/checkmark.png"
                                                         alt="Checkmark">
                                                </div>
                                            </div>
                                        </div>
                                    </true-panel>

                                </section>
                            </section>

                        </section>
                    </transition>
                    <!-- END ANALYZED && TRUEAdvice -->

                    <transition name="fade">
                        <div class="continueButton"
                             v-if="areaOfConcern.equipmentOptionChosen">
                            <button class="button full"
                                    @click="add">Done</button>
                        </div>
                    </transition>

                </section>
            </AocView>

            <a href="javascript:;"
                   class="button continue-button-override button-full"
                   @click="skipEquipment"
                   v-if="!areaOfConcern.equipmentOptionChosen">
                    Continue without adding protection
                </a>

            <!-- IF BASEMENT UNPROTECTED -->
                <!-- <inline-advice v-if="adviseToProtectBasement"
                               :expand="false">
                    <div slot="title">Your basement is unprotected</div>
                    <div slot="text">
                        We noticed you have a finished basement. If you have any windows in your basement that are accessible from outside then you should protect the basement also!
                    </div>
                    <div slot="action">
                        <a href="javascript:;"
                           @click="protectBasement">Protect my basement</a>
                    </div>
                </inline-advice> -->

                <!-- IF MULTIPLE EQUIPMENT OPTIONS -->
                <inline-advice v-if="areaOfConcern.equipmentOptions['alternative']"
                               :expand="false">
                    <div slot="title">Which should I choose?</div>
                    <div slot="text">
                        <p>
                            Window sensors are the best option if you are concerned when you are home or away.
                        </p>
                        <p>
                            Glassbreak sensors are an economical solution for protecting a room with several windows.
                        </p>
                    </div>
                    <div slot="action">
                        <a href="/assessment/help/equipment">Learn more about glassbreak sensors</a>
                    </div>
                </inline-advice>

                <!-- IF MULTIPLE EQUIPMENT OPTIONS -->
                <inline-advice v-if="areaOfConcern.equipmentOptions['alternative']"
                               :expand="false">
                    <div slot="title">Looking for a motion sensor?</div>
                    <div slot="text">
                        <p>
                            Motion sensors are great for when you're away. But when you’re home they can cause unwanted alarms. Motion sensors are not armed when you are home.
                        </p>
                    </div>
                    <div slot="action">
                        <a href="javascript:;"
                           @click="toggleInterestedInMotion">I would like to add a motion sensor for this room.</a>
                    </div>
                </inline-advice>

        </div>
    </section>
</template>



<script>
import { mapActions, mapState } from 'vuex'
import NoAccessibleWindowsWarning from '../../components/AreaOfConcern/NoAccessibleWindowsWarning.vue'
import AocView from '../../components/AocView.vue'

export default {
    components: {
        AocView,
        NoAccessibleWindowsWarning
    },
    data: () => ({
        motionExpanded: false
    }),
    computed: {
        ...mapState(['areaOfConcern', 'emptyAreaOfConcern', 'lead']),

        recommended() {
            return this.areaOfConcern.equipmentOptions.recommended
        },

        alternative() {
            return this.areaOfConcern.equipmentOptions.alternative
        },

        motion() {
            return this.areaOfConcern.equipmentOptions.motion
        },

        recommendedChosen() {
            return this.areaOfConcern.equipmentOptionChosen === 'recommended'
        },

        alternativeChosen() {
            return this.areaOfConcern.equipmentOptionChosen === 'alternative'
        },

        motionChosen() {
            return this.areaOfConcern.equipmentOptionChosen === 'motion'
        }
    },
    methods: {
        ...mapActions([
            'updateAreaOfConcern',
            'addArea',
            'resetArea',
            'save',
            'addAreaOfConcern',
            'setAocSectionIndex',
            'incrementAocSectionIndex',
        ]),

        add() {
            window.scrollTo(0, 0)
            this.addArea()
            if (this.lead.areasOfConcern.length > 1) {
                this.resetArea()
                return
            }
            this.incrementAocSectionIndex()
        },

        skipEquipment() {
            this.addArea()
            this.resetArea()
        },

        addArea() {
            this.addAreaOfConcern(this.areaOfConcern)
            this.save()
        },

        resetArea() {
            // Empty the local area of concern
            this.updateAreaOfConcern(this.emptyAreaOfConcern)
            this.setAocSectionIndex(-1)
        },

        toggleMotionExpanded() {
            this.motionExpanded = !this.motionExpanded
        },

        toggleInterestedInMotion() {
            this.updateAreaOfConcern({
                interestedInMotion: !this.areaOfConcern.interestedInMotion
            })
        },

        selectEquipment(type) {
            if (type === this.areaOfConcern.equipmentOptionChosen) {
                type = ''
            }
            this.updateAreaOfConcern({
                equipmentOptionChosen: type
            })
        },

        analyzeArea() {
            // Determine window equipment
            let params = {
                area: this.areaOfConcern
            }
            axios
                .get('/ajax/true-advice/area-of-concern', {
                    params
                })
                .then(res => {
                    let data = res.data
                    this.updateAreaOfConcern(data)
                    // this.$router.push('/assessment/areas-of-concern/equipment')
                })
        }
    },
    mounted() {
        if (this.areaOfConcern.name !== '') {
            this.analyzeArea()
        }
    }
}
</script>

<style lang="css"></style>
